/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var LAST_CHANNEL_TIMEOUT = 3000,
    lastChannelTimeout;

module.exports = {
    /**
     * Show error notification.
     *
     * @param {string} text to show
     * @param {number} [duration] in seconds
     */
    notifyError: function ( text, duration ) {
        duration = duration * 1000 || 3000;

        core.notify({
            title: text,
            icon: 'alert',
            type: 'warning',
            timeout: duration
        });
    },

    /**
     * Create timeout to set channel as last.
     *
     * @param {Channel} channel to set as last
     */
    setChannelAsLast: function ( channel ) {
        clearTimeout(lastChannelTimeout);
        lastChannelTimeout = setTimeout(function () {
            channel.setLast();
        }, LAST_CHANNEL_TIMEOUT);
    },

    /**
     * Send osd-input intent.
     *
     * @param {number} number pressed to send
     * @param {Object} config intent reaction
     */
    sendOsdInputIntent: function ( number, config = {} ) {
        core.intent({
            action: 'osd-input',
            data: {
                type: 'numbers',
                length: 4,
                startChar: number
            },
            events: {
                done: result => config.callback && config.callback(result)
            }
        });
    },

    /**
     * Send intent to call keyboard with search params.
     *
     * @param {string} initialValue of keyboard input
     * @param {function} callback after user input
     */
    sendSearchIntent: function ( initialValue, callback ) {
        window.core.intent({
            action: 'keyboard',
            data: {
                type: 'text',
                mode: 'qwerty',
                title: gettext('Search'),
                description: '',
                value: initialValue || ''
            },
            events: {
                done: function ( event ) {
                    event = event || {};

                    if ( callback ) {
                        callback(event.value);
                    }
                }
            }
        }, function ( error ) {
            console.log(error);
        });
    },

    /**
     * Send intent to record manager with given channel.
     *
     * @param {Channel} channel to record
     */
    sendRecordIntent: function ( channel ) {
        if ( !channel || (!channel.pvr && !channel.local_pvr) ) {
            return;
        }

        core.intent({
            action: 'record',
            data: {
                uri: channel.url,
                name: channel.name,
                id: channel.id,
                pvr: {
                    server: channel.pvr,
                    local:  channel.local_pvr
                }
            }
        });
    },

    /**
     * Shortcut function to check if channel is under censored.
     *
     * @param {Channel} channel to check
     * @return {boolean} state of censored
     */
    isCensored: function ( channel ) {
        return (channel.censored || (channel.genre && channel.genre.censored));
    },

    /**
     * Send intent to show osd tv.
     *
     * @param {Channel} channel - channel to send info
     * @param {boolean} [attach] - attach osd on screen
     * @return {Intent} intent - intent to osd
     */
    sendOsdTvIntent: function ( channel, attach ) {
        return core.intent({
            action: 'osd-tv',
            data: {
                name: channel.name,
                number: channel.number,
                favorite: channel.favorite,
                pvr: (channel.local_pvr || channel.pvr),
                timeshift: channel.local_timeshift,
                censored: channel.censored || ( channel.genre && channel.genre.censored ),
                // stay on display
                attach: attach
            }
        }, function () {
            debug.log('send osd intent');
        });
    }

};
